import { type HttpClient } from '../useHttpClient';

export const duplicateNudge =
  (httpClient: HttpClient) => async (id: number | string) => {
    const response = await httpClient.api(`/admin/nudges/${id}/duplicate`, {
      method: 'POST',
    });

    return { data: response.json };
  };
